module.exports = __webpack_public_path__ + "img/crown.c01bfaa0.svg";